<template>
  <div class="content">
    <!--  -->
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>人员信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <!-- 侧边树 -->
      <el-aside width="15%" style="height:100%" class="aside">
        <!-- <div style="height:13%">
          <el-input
            v-model="search.entName"
            placeholder="请输入企业班组名称"
            style="margin-bottom: 10px; width: 85%;margin-top: 20px;font-size:12px"
            clearable
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div> -->
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
              :data="dataTree"
              :props="defaultProps"
              default-expand-all
              :expand-on-click-node="false"
              highlight-current
              @node-click="handleNodeClick"
          ></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main
          class="build-CURD"
          style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px">
            <el-button-group style="text-align:right;display:block">
              <el-button plain @click="doFilter(2)" :class="{cur : search.personStatus==2}">未分配</el-button>
              <el-button plain @click="doFilter(0)" :class="{cur : search.personStatus==0}">在职</el-button>
              <el-button plain @click="doFilter(1)" :class="{cur : search.personStatus==1}">离职</el-button>
            </el-button-group>
            <div class="grid-search">
              <el-input v-model="search.name" style="width:200px" placeholder="请输入姓名" clearable
                        @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div
                style="display:flex;margin:0px 0px 0px 0px;width: 20%;justify-content:space-between;align-items:center">
              <!-- 测试短信 -->
              <!-- <el-tooltip class="item" effect="dark" content="测试" placement="top-end">
                           <img @click="test" class="icon_hover" src="../../assets/image/send.png" alt="" srcset="">
              </el-tooltip> -->
              <el-button type="primary" size="mini" @click="sendMessage" v-if="isMenuExit('pro.worker.msg')">短信
              </el-button>
              <!-- <el-button type="primary" plain @click="exportWorker">花名册</el-button> -->
              <!-- <el-button type="primary" @click="attendVisible = true">批量下发</el-button> -->
              <!-- <el-tooltip class="item" effect="dark" content="发送短信" placement="top-end">
                           <img @click="sendMessage" class="icon_hover" src="../../assets/image/send.png" alt="" srcset="">
              </el-tooltip> -->
              <el-tooltip class="item" effect="dark" content="花名册" placement="top-end"
                          v-if="isMenuExit('pro:worker:rost')">
                <div class="tips">
                  <img @click="exportWorker" class="icon_hover" src="../../assets/image/hua.png" alt="" srcset="">
                  <span>花名册</span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="批量下发" placement="top-end"
                          v-if="isMenuExit('pro:worker:down')">
                <div @click="sendSome" class="tips">
                  <img class="icon_hover" src="../../assets/image/xiafa.png" alt="" srcset="">
                  <span>批量下发</span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="班组配置" placement="top-end"
                          v-if="isMenuExit('pro:worker:conf')">
                <div class="tips" @click="push">
                  <img class="icon_hover" src="../../assets/image/peizhi.png" alt="" srcset="">
                  <span>班组配置</span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="批量出场" placement="top-end"
                          v-if="isMenuExit('pro:worker:outBatch')">
                <div class="tips" @click="outTeam">
                  <img class="icon_hover" src="../../assets/image/chu.png" alt="" srcset="">
                  <span>批量出场</span>
                </div>

              </el-tooltip>
              <!-- <el-button type="primary" @click="push">班组配置</el-button> -->
              <!-- <el-button type="primary" @click="outTeam">批量出场</el-button> -->
            </div>
            <!-- <div style="display:flex;margin:20px 0px 0px 0px;align-items: center;">
              <el-button type="primary" plain>拖拽项管理</el-button>

              <el-button type="primary" plain>打印</el-button>
            </div> -->
          </div>
          <!-- <div style="margin: 0px 20px 20px;display:flex;justify-content: space-between;justify-content: space-between;height:40px" >
            <el-button-group style="text-align:right;display:block">
              <el-button plain @click="doFilter(2)"  :class="{cur : search.personStatus==2}">未入职</el-button>
              <el-button plain @click="doFilter(0)"  :class="{cur : search.personStatus==0}">在职</el-button>
              <el-button plain @click="doFilter(1)"  :class="{cur : search.personStatus==1}">离职</el-button>
            </el-button-group>
            <div style="display:flex;margin:0px 0px 0px 0px;">
              <el-button type="primary" plain @click="exportWorker">花名册</el-button>
              <el-button type="primary" @click="attendVisible = true">批量下发</el-button>
              <el-button type="primary" @click="push">班组配置</el-button>
            </div>
          </div> -->
          <div class="build-table">
            <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{ dataText }}</p>
              </template>
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index + 1 }}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="200">
                <template slot-scope="scope">
                  <div style="display:flex;">
                    <img
                        v-if="scope.row.idcardPhoto!=''"
                        :src="scope.row.idcardPhoto"
                        style="width:3.5vw;height:9vh;"
                    />
                    <div
                        v-else
                        style="width:3.5vw;height:9vh;background: #ddd;display: flex;align-items: center;justify-content: center;"
                    >暂无图片
                    </div>
                    <div style="padding-left:1vh;display:flex;flex-wrap:wrap;width:100px;">
                      <p style="width:100%;text-align: left;padding-top: 1vh;">{{ scope.row.name }}</p>
                      <p style="width:100%;text-align: left;padding-top: 1vh;">{{ scope.row.idcard }}</p>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="年龄" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.age }}</span>
                </template>
              </el-table-column>
              <el-table-column label="班组">
                <template slot-scope="scope">
                  <span>{{ scope.row.teamsName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="工种">
                <template slot-scope="scope">
                  <span>{{ scope.row.typeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="在职状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.outFlag=='0'||scope.row.outFlag=='2'" style="color:#86A0F3">在职</span>
                  <span v-if="scope.row.outFlag=='1'" style="color:#F56C6C">离职</span>
                  <!-- <span v-if="scope.row.outFlag=='2'" style="color:#86A0F3">未入职</span> -->
                </template>
              </el-table-column>
              <el-table-column label="入职日期" prop="createDate" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="采集时间" prop="updateDate">
                <template slot-scope="scope">
                  <span>{{ scope.row.updateDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="联系电话" width="200">
                <template slot-scope="scope">
                  <div style="display:flex;align-items:center;height:4vh;">
                    <span style="margin-right:1vw;">{{ scope.row.phone }}</span>
                    <el-button type="primary" plain v-if="isMenuExit('pro:worker:edit')" icon="el-icon-edit" size="mini"
                               style="position: absolute;right: 0.5vw;" @click="modInfo(scope.row)"></el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.outFlag=='0' && isMenuExit('pro:worker:out')" size="mini" type="danger"
                             plain style="margin-top:0.5vh;margin-bottom:0.5vh;"
                             @click="handleDelete(scope.$index,scope.row)">离职
                  </el-button>
                  <el-button type="success" plain size="mini" @click="sumbitInfo(scope.row)"
                             style="margin-top:0.5vh;margin-bottom:0.5vh;">个人档案
                  </el-button>
                  <el-button size="mini" @click="personInfo(scope.$index, scope.row)">考勤信息</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div>

              <!-- <script>document.forms[0].submit();</script> -->
            </div>
            <!-- 批量下发窗口 -->
            <el-dialog
                title="考勤下发列表"
                :visible.sync="attendVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                width="30%"
            >
              <el-table
                  :data="attendData"
                  height="300"
                  border
                  style="width: 100%"
                  @selection-change="attendChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="imei" label="考勤机序列号"></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span>{{ scope.row.statusName }}</span>
                    <!-- <span v-if="scope.row.status=='0'">进闸</span>
                <span v-else-if="scope.row.status=='1'">出闸</span>
                <span v-else-if="scope.row.status=='3'">未配置</span>
                <span v-else-if="scope.row.status=='4'">采集机</span>
                <span v-else-if="scope.row.status=='5'">特种使用</span>
                    <span v-else></span>-->
                  </template>
                </el-table-column>
              </el-table>
              <div slot="footer" class="dialog-footer">
                <el-button @click="attendVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAttend()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 班组配置 表格-->
            <el-dialog
                width="30%"
                title="班组配置"
                :append-to-body="true"
                :lock-scroll="false"
                :visible.sync="classVisible"
            >
              <el-table :data="classData" height="400" border style="width: 100%">
                <el-table-column label width="55">
                  <template scope="scope">
                    <el-radio
                        :label="scope.row.id"
                        v-model="classId"
                        @change.native="getRadioRow(scope.$index,scope.row)"
                    >{{ '' }}
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="name" label="班组"></el-table-column>
              </el-table>
              <div slot="footer" class="dialog-footer">
                <el-button @click="classVisible = false">取 消</el-button>
                <el-button type="primary" v-if="classBtnFlag" @click="sumbitClass()">确 定</el-button>
                <el-button type="primary" v-else disabled>确 定</el-button>
              </div>
            </el-dialog>
            <!-- 人员修改 -->
            <el-dialog width="500px" title="人员修改" :visible.sync="modifyVisible" append-to-body>
              <el-form
                  :model="workerInfo"
                  ref="workerInfo"
                  label-width="160px"
                  label-position="right"
              >
                <el-form-item label="姓名：">
                  <p>{{ workerInfo.name }}</p>
                </el-form-item>
                <el-form-item label="身份证号：">
                  <p>{{ workerInfo.idcard1 }}</p>
                </el-form-item>
                <el-form-item label="手机号码：">
                  <el-input v-model="workerInfo.phone" autocomplete="off" style="width:10vw;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyWorkerInfo()">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 分配班组成功 -->
            <el-dialog
                :title="dialogTitle1"
                :visible.sync="imoportVisible"
                center
                :append-to-body="true"
                :before-close="handleClose1"
                :lock-scroll="false"
                width="30%"
            >
              <template>
                <el-table :data="tableData1" style="width: 100%" border>
                  <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status==0||scope.row.code==200">
                        <i class="el-icon-circle-check" style="color:#07C160"></i>
                      </span>
                      <span v-if="scope.row.status==1||scope.row.code!=200">
                        <i class="el-icon-warning-outline" style="color:#f00"></i>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status==0||scope.row.code==200"
                            style="color:#07C160">{{ scope.row.result || scope.row.msg }}</span>
                      <span v-if="scope.row.status==1||scope.row.code!=200"
                            style="color:#f00">{{ scope.row.result || scope.row.msg }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-dialog>
            <!-- 短信弹出框 -->
            <el-dialog
                title="发送内容"
                :visible.sync="messageVisible"
                width="50%"
                class="send"
                center>
              <div class="dialog_send">农民工朋友：</div>
              <div class="dialog_send">您好！感谢您为我**项目的辛苦付出，为维护您的合法权益，现温馨提示：</div>
              <div class="dialog_send">
                1.进场后1个月内，须与我单位签订书面劳动合同，明确相应工种、岗位的劳动报酬标准、支付方式等条款。
              </div>
              <div class="dialog_send">
                2.我项目实行实名制管理，按月生成的考勤表经您本人签字确认后，连同每月工资发放表作为您工资发放的依据。
              </div>
              <div class="dialog_send">
                3.您的工资将按月通过委托银行直接打入您的实名制工资卡，请配合项目部统一办理实名制工资卡或提供您的社保卡。实名制工资卡关乎财产安全，请您妥善保管，密码由本人掌握。
              </div>
              <div class="dialog_send">
                4.我项目已设置农民工维权信息告示牌，对您的考勤、工资发放以及专用账户信息等，逐月张贴公示，请注意核对。
              </div>
              <div class="dialog_send">
                如您对我项目工资发放存有异议，请第一时间联系项目部负责人或劳资专管员反映，联系人***，联系电话***。
              </div>
              <div class="dialog_end"> ***项目部</div>
              <div class="dialog_end">2020年*月*日</div>
              <div class="dialog_end else">
                <div>发送人数:{{ number }}人</div>
                <div>
                  <span>短信条数</span>
                  <span style="color:#EA3434">(0.1元/条)</span>
                </div>
                <div><span>合计费用</span><span style="color:#EA3434">{{ money }}元</span></div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="messageVisible = false">取 消</el-button>
                <el-button type="primary" @click="conmfirm">去支付</el-button>
              </span>
            </el-dialog>
            <!-- 没有专员 -->
            <el-dialog
                :visible.sync="fillVisible"
                width="20%"
                class="send"
                center>
              <div style="width:15%;margin:auto">
                <img src="../../assets/image/warning.png" alt="">
              </div>
              <div style="text-align:center">请填写劳资员岗位和联系方式才能发送</div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="fillVisible = false">取 消</el-button>
                <el-button type="danger" plain @click="edit()">去填写</el-button>
              </span>
            </el-dialog>
            <!-- 支付宝页面 -->
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'

export default {
  data() {
    return {
      listData: [],
      search: {
        //查询
        name: '',
        projectId: '',
        personStatus: '2', // 0-在职；1-离职；2-未入职
        teamsId: '',
        entId: '',
        entName: '',
      },
      date: '',
      dataText: '数据加载中...',
      dataTree: [], //树形列表
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      attendVisible: false, //考勤机弹出框
      attendData: [], //考勤设备列表
      classVisible: false, //班组弹出框
      classData: [], //班组数据
      classId: '', //班组id
      attendSel: [], //考勤机选择
      personIdStr: '', //人员选择（下发）
      ids: '', //人员信息id（班组配置）
      personIdClass: '', //人员选择(班组配置)
      dataText: '数据加载中...',
      dialogTitle1: '配置结果',
      statusper: [
        {label: '在职', value: '0'},
        {label: '离职', value: '1'}
        // { label: '未入职', value: '2' }
      ], //筛选人员状态
      personStu: '0',
      Phone: [],
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0
      modifyVisible: false,
      imoportVisible: false,
      workerInfo: {
        id: '',
        name: '',
        idcard: '',
        phone: '',
        idcard1: ''
      },
      typeNameAll: [], //考勤机类型字典表
      workerType: [], //工种列表
      managerType: [],//岗位列表
      tableData1: [],
      messageVisible: false, //发送短信弹出框
      fillVisible: false,//无联系
      zfbVisible: false,
      selsectPerson: [],
      number: '',
      money: '',
      address: '',
      phone1: '',

      classBtnFlag: true,//当前班组配置提交中
    }
  },
  created() {
    this.search.projectId = util.session.get('groupId')
  },
  mounted() {
    this.search.projectId = util.session.get('groupId')
    if (this.search.projectId == '') {
      this.$store.commit('setGroupId')
      this.search.projectId = this.$store.state.groupId
    }
    this.getData()
    this.getDict()
    // this.getAttendList()
    this.getClass()
    this.getTypeDict('position') //获取岗位
    this.getTypeDict('worktype') //获取工种
    this.teamTree() //获取组织树
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.search.personStatus = index
      // if(index==2){
      //   this.search.teamName = '未分配班组'
      //   this.search.personStatus = '0'
      // }else{
      //   this.search.teamName = ''
      // }
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.listData = []
      if (this.search.personStatus == 2) {
        this.search.personStatus = '2'
      }
      myHttp.getProjectPersonManagerList(this.search).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].idcardPhoto =
                    list[i].idcardPhoto && list[i].idcardPhoto != ''
                        ? base.httpCtx + list[i].idcardPhoto
                        : ''
                list[i].createDate =
                    list[i].createDate && list[i].createDate != ''
                        ? list[i].createDate.split(' ')[0]
                        : ''
                list[i].age = util.myTime.getAge(list[i].birthday)
              }
              that.listData = list
              that.getTypeName()
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () {
          }
      )
    },
    //获取考勤机
    getAttendList() {
      var that = this
      myHttp
          .getRecogByProjectId1({
            projectId: this.search.projectId
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo || []
              for (var i = 0; i < list.length; i++) {
                list[i].statusName = that.filterSatus(list[i].status)
              }
              that.attendData = list
            }
          })
    },
    //获取类型
    filterSatus(str) {
      var list = this.typeNameAll
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //获取班组
    getClass() {
      var that = this
      myHttp
          .getTeams1({
            projectId: this.search.projectId
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.classData = resp.data.data.pageInfo || []
            }
          })
    },
    //人员表格选择
    handleSelectionChange(val) {
      this.selsectPerson = val
      // console.log(val)
      for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.personIdStr = val[i].personId
          this.phone1 = val[i].phone
        } else {
          this.personIdStr += ',' + val[i].personId
          this.phone1 += ',' + val[i].phone
        }
        //班组配置人员
        if (undefined == val[i].teamsName ||
            '' == val[i].teamsName ||
            '0' != val[i].outFlag
        ) {
          if (this.personIdClass == '') {
            this.personIdClass = val[i].personId
          } else {
            this.personIdClass += ',' + val[i].personId
          }
          if (this.ids == '') {
            this.ids = val[i].id
          } else {
            this.ids += ',' + val[i].id
          }
        }
        this.phone = val
      }
    },
    //考勤机表格选择
    attendChange(val) {
      for (var i = 0; i < val.length; i++) {
        if (i == 0) {
          this.attendSel = val[i].imei
        } else {
          this.attendSel += ',' + val[i].imei
        }
      }
    },
    //考勤选择后点击确认
    sumbitAttend() {
      var that = this
      if (this.personIdStr == '' || this.attendSel == '') {
        that.$message.error('请选择下发人员或设备！')
        return
      }
      myHttp
          .downWorker({
            personIdStr: this.personIdStr,
            machineIdStr: this.attendSel
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('下发成功')
              that.attendVisible = false
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    //班组选择
    getRadioRow(index, row) {
    },
    //班组配置
    sumbitClass: function () {

      var that = this
      this.classBtnFlag = false
      for (var i = 0; i < this.phone.length; i++) {
        if (this.phone[i].phone == '' || undefined == this.phone[i].phone) {
          that.$message.error('请到个人档案完善手机号！')
          this.classBtnFlag = true
          return
        }
      }
      myHttp.joinTeamsBatchNow({
        teamsId: this.classId,
        personIdStr: this.personIdStr,
        idStr: this.ids,
        operationPerson: util.session.get('user').id,
        projectId: util.session.get('groupId')
      })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.tableData1 = resp.data.data.List || []
              that.classVisible = false
              that.getData()
              that.imoportVisible = true
              // for(var i = 0;i<that.tableData1.length;i++){
              //   if(that.tableData1[i].status==0){
              //     that.$message.success(that.tableData1[i].msg)
              //   }else{
              //     that.$message.error(that.tableData1[i].msg)
              //   }
              // }
            } else {
              that.$message.error(resp.data.msg)
            }
            that.classBtnFlag = true
          }, function () {
            that.classBtnFlag = true
          })
    },
    //个人档案
    sumbitInfo(row) {
      var id = row.personId
      this.$router.push({
        name: 'perFile',
        params: {id: id, groupId: this.search.projectId}
      })
    },
    //考勤详情
    personInfo(index, row) {
      var id = row.personId
      this.$router.push({name: 'workerInfo', params: {id: row.personId}})
    },
    // 改变人员状态
    filterName1(e) {
      this.search.personStatus = e
      this.getData()
    },
    //修改人员信息
    modInfo(row) {
      this.modifyVisible = true
      var that = this
      myHttp
          .getPersonInfoById({
            id: row.personId
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var data = resp.data.data.person
              that.workerInfo = {
                id: data.id,
                name: data.name,
                idcard1: row.idcard,
                idcard: data.idcard,
                phone: data.phone
              }
            } else {
              that.$message.success(resp.data.msg)
            }
          })
    },
    //提交修改信息
    modifyWorkerInfo() {
      var that = this
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.workerInfo.phone)) {
        this.$message.success('请输入正确的手机号')
        return;
      }
      delete this.workerInfo.idcard1
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.workerInfo.phone)) {
        this.$message.success('请输入正确的手机号')
        return;
      }
      myHttp.modProjectPerson({
        projectId: this.search.projectId,
        ...this.workerInfo
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.$message.success('修改成功')
          that.modifyVisible = false
          that.getData()
        } else {
          that.$message.success(resp.data.msg)
        }
      })
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val
    //   this.currentChangePage()
    // },
    // 监控当前页码
    // currentChangePage(list) {
    //   this.getData()
    // }
    exportWorker() {
      var token = util.session.get('token')
      window.open(
          myHttp.exportTeamsPersons +
          '?projectId=' +
          this.search.projectId +
          '&personStatus=' +
          this.search.personStatus +
          '&teamName=' +
          this.search.teamName +
          '&name=' +
          this.search.name +
          '&accessToken=' +
          token
      )
    },
    //字典表（考勤机类型）
    getDict() {
      var that = this
      myHttp
          .getDictByType({
            type: 'attend_type'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.typeNameAll = resp.data.data.dictList
              that.getAttendList()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    //获取字典类型
    getTypeDict(type) {
      var that = this
      myHttp
          .getDictByType({
            type: type
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              if (type == 'position') {
                that.managerType = resp.data.data.dictList
              } else {
                that.workerType = resp.data.data.dictList
              }
              that.getTypeName()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    //展示工种或者岗位
    getTypeName() {
      //var list = this.listData
      if (this.listData.length == 0) {
        return
      }
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].teamsType == '1') {
          this.listData[i].typeName = this.getNameById(
              this.listData[i].teamsWork,
              this.workerType
          )
        } else {
          this.listData[i].typeName = this.getNameById(
              this.listData[i].teamsWork,
              this.managerType
          )
        }
      }
    },
    //获取数据名称
    getNameById(id, list) {
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      if (data.type == '1') {
        this.search.entId = data.parentId
        this.search.teamsId = ''
      } else if (data.type == '0') {
        this.search.entId = ''
        this.search.teamsId = data.id
      } else {
        this.search.entId = ''
        this.search.teamsId = ''
      }
      if (data.status == '2') {
        this.search.personStatus = '2'
      } else {
        this.search.personStatus = this.personStu
      }
      this.getData()
    },
    //获取树形结构
    teamTree() {
      var that = this
      myHttp
          .getEntTeams({
            projectId: this.search.projectId
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              var list = resp.data.data.list || []
              var tree = util.common.listToTree('id', 'parentId', list)
              var obj = [{name: '全部', id: '', parentId: '', children: []}]
              // var noJob = { name: '未入职', id: '', parentId: '', status: '2' }
              // tree.push(noJob)
              obj[0].children = tree
              that.dataTree = obj
              console.log(that.dataTree)
            }
          })
    },
    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
    push() {
      if (this.selsectPerson.length != 0) {
        this.classVisible = true
        this.getClass()
      } else {
        this.$message.warning('请选择人员')
        return
      }
    },
    exportWorker() {
      var token = util.session.get('token')
      window.open(
          myHttp.exportTeamsPersons +
          '?projectId=' +
          this.search.projectId +
          '&personStatus=' +
          this.search.personStatus +
          '&teamsId=' +
          this.search.teamsId +
          '&name=' +
          this.search.name +
          '&accessToken=' +
          token
      )
    },
    handleClose1(done) {
      this.imoportVisible = false
    },
    //批量出场
    outTeam() {
      var that = this
      if (this.personIdStr == '') {
        that.$message.warning('请选择工人！')
        return
      }
      this.$confirm('确认工人离场吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.outTeamsBatchByProjectId({
          idStr: that.personIdStr,
          projectId: that.search.projectId,
          operationPerson: util.session.get('user').id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('离场成功')
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
    //个人离场
    handleDelete(index, row) {
      var that = this
      this.$confirm('确认该人员（' + row.name + '）离场吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.outTeamsBatch({
          idStr: row.personId,
          teamsId: row.teamsId,
          operationPerson: util.session.get('user').id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('离场成功')
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
    /**
     * 批量下发
     */
    sendSome() {
      this.selsectPerson
      if (this.selsectPerson.length != 0) {
        this.attendVisible = true
      } else {
        this.$message.warning('请选择需要下发的人员')
        return
      }
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      var flag = util.common.filterBtnMenu(row)
      return flag
    },
    // 发送短信
    sendMessage() {
      // 判断是否有劳资专管员或者项目经理的手机号码
      var that = this
      // judgePhone
      myHttp
          .judgePhone({
            // projectId: this.search.projectId
            projectId: '1175661048930197506'
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              // console.log(resp)
              var number = that.selsectPerson.length
              that.number = number
              if (number == 0) {
                that.$message.error("请选择人员")
                return
              }

              that.messageVisible = true

              // console.log(number)
              that.setMoney(number)
            } else {
              that.fillVisible = true
            }
          })
    },
    // 计算金额
    setMoney(number) {
      var that = this
      myHttp
          .paymentAmount({
            number: number
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              that.money = resp.data.data.pageInfo.money
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    randomWord(randomFlag, min, max) {
      var str = '',
          range = min,
          arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
      //随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        var pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos]
      }
      return str;
    },

    // 挑战班组页面
    edit() {
      this.$router.push({path: '/teamMan'})
    },
    conmfirm() {
      // send
      var that = this
      var subject = this.randomWord(false, 32)
      myHttp
          .send({
            money: this.money,
            subject: subject
          })
          .then(function (resp) {
            that.address = resp.data
            if (resp.data) {
              //打开新页面
              let routerData = that.$router.resolve({path: '/applyText', query: {htmls: resp.data}})
              window.open(routerData.href, '_ blank')
              const div = document.createElement('div');
              div.innerHTML = htmls;
              document.body.appendChild((div),
                  document.forms [0].submit())
            } else {
              that.$message.error(resp.data.msg)
            }
          })
    },
    // 测试发送短信
    test() {
      var that = this
      // sendMessages
      var that = this
      console.log(this.selsectPerson)
      myHttp
          .sendMessages({
            projectId: this.search.projectId,
            phone: this.phone1
          })
          .then(function (resp) {
            //console.log(resp)
            if (resp.data.code == '200') {
              that.money = resp.data.data.pageInfo.money
            } else {
              that.$message.error(resp.data.msg)
            }
          })

    }

  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}

.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}

.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}

.build-table {
  height: calc(100% - 80px);
}

.cur {
  background: #ECF5FF !important;
  /* border: 1px solid   #409EFF !important ; */
  color: #409EFF !important;
}

/* .build-CURD>>>.el-card__body{
 height: 100%;
}  */
div >>> .el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center !important;
}

.send >>> .el-dialog__header {
  text-align: left !important;
}

div >>> .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: center;
  box-sizing: border-box;
}

div >>> .el-input-group--append .el-input__inner {
  width: 200px;
}

.dialog_send {
  margin: 10px 0px 10px 35px;
}

.dialog_end {
  padding: 30px 0px 10px 35px;
  display: flex;
  justify-content: flex-end;
}

.else {
  justify-content: space-between;
  border-top: 1px dotted #ECF5FF;
}

.tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
}
</style>
